"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchDigestStepResponseDto = instanceOfPatchDigestStepResponseDto;
exports.PatchDigestStepResponseDtoFromJSON = PatchDigestStepResponseDtoFromJSON;
exports.PatchDigestStepResponseDtoFromJSONTyped = PatchDigestStepResponseDtoFromJSONTyped;
exports.PatchDigestStepResponseDtoToJSON = PatchDigestStepResponseDtoToJSON;
exports.PatchDigestStepResponseDtoToJSONTyped = PatchDigestStepResponseDtoToJSONTyped;
/**
 * Check if a given object implements the PatchDigestStepResponseDto interface.
 */
function instanceOfPatchDigestStepResponseDto(value) {
    if (!('savedAt' in value) || value['savedAt'] === undefined)
        return false;
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    if (!('sportCode' in value) || value['sportCode'] === undefined)
        return false;
    if (!('stepId' in value) || value['stepId'] === undefined)
        return false;
    if (!('selection' in value) || value['selection'] === undefined)
        return false;
    return true;
}
function PatchDigestStepResponseDtoFromJSON(json) {
    return PatchDigestStepResponseDtoFromJSONTyped(json, false);
}
function PatchDigestStepResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'savedAt': json['savedAt'],
        'sportCodes': json['sportCodes'],
        'sportCode': json['sportCode'],
        'stepId': json['stepId'],
        'selection': json['selection'],
    };
}
function PatchDigestStepResponseDtoToJSON(json) {
    return PatchDigestStepResponseDtoToJSONTyped(json, false);
}
function PatchDigestStepResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'savedAt': value['savedAt'],
        'sportCodes': value['sportCodes'],
        'sportCode': value['sportCode'],
        'stepId': value['stepId'],
        'selection': value['selection'],
    };
}
